function transform(_tagName, attribs) 
{
    const attributes = {
        tagName: 'a',
        attribs: { ...attribs },
    };

    if (attribs.target) 
    {
        if (attribs.rel !== undefined) 
        {
            if (!attribs.rel.includes('noopener')) 
            {
                attributes.attribs.rel = `${attribs.rel} noopener`;
            }
        }
        else 
        {
            attributes.attribs.rel = 'noopener';
        }
    }

    return attributes;
}

const allowedAttributes = ['href', 'name', 'target', 'rel'];

export default {
    allowedAttributes,
    transform,
};
